<template>
    <div id="d-group-profile">
        <div class="grid pb-0">
            <div class="grid-title d-flex">
                <h4>{{ $t("LIST_PROFILE_GROUP") }}</h4>
                <div>
                    <v-btn color="primary" class="pr-5" @click="addNew()">
                        <i class="icon-plus mr-2 fs-18"></i>
                        {{ $t("ADD_NEW") }}
                    </v-btn>
                </div>
            </div>
            <div class="grid-body border-top-unset list-booking-group">
                <div class="d-flex flex-wrap p-3">
                    <div class="mb-3 mr-auto w-50">
                        <v-text-field class="w-100" v-model="search" dense outlined
                            :placeholder="$t('SEARCH_BY_PROFILE_NAME_AND_CODE')"></v-text-field>
                    </div>
                </div>

                <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>

                <v-data-table v-if="!isLoading" :headers="headers" :items="dataTable" :search="search" class="elevation-1"
                    hide-default-footer :items-per-page="15" :page.sync="page" @page-count="pageCount = $event">
                    <template v-slot:item.stt="{ item, index }">
                        {{ (index + 1) + (page * 15 - 15) }}
                    </template>
                    <template v-slot:item.nameVi="{ item, index }">
                        <a class="app-link text-decoration-none font-weight-bold" href="javascript:;"
                            @click="editItem(item)">
                            {{
                                item.nameVi
                            }}
                        </a>
                    </template>
                    <template v-slot:item.status="{ item, index }">
                        <v-tooltip top transition="slide-y-reverse-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn depressed @click="editItem(item)" x-small class="rounded-sm mr-1" v-bind="attrs"
                                    v-on="on" color="primary" outlined>
                                    <i class="icon-edit fs-16"></i>
                                </v-btn>
                            </template>
                            {{ $t("EDIT") }}
                        </v-tooltip>
                        <v-tooltip top transition="slide-y-reverse-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn depressed color="error" @click="$refs.deleteDialogComponent.open(item)" x-small
                                    v-bind="attrs" v-on="on" class="rounded-sm" outlined>
                                    <i class="icon-delete fs-16"></i>
                                </v-btn>
                            </template>
                            {{ $t("DELETE") }}
                        </v-tooltip>
                    </template>
                    <template v-slot:no-data>
                        <div class="text-center">{{ $t('$vuetify.noDataText') }}</div>
                    </template>
                </v-data-table>
                <div class="d-flex align-items-center justify-content-end">
                    <span slot="totalItems">{{ $t("TOTAL") }}: {{ $tc("PROFILE_NUMBER", dataTable.length) }}</span>
                    <v-pagination v-model="page" :length="pageCount" :total-visible="5"></v-pagination>
                </div>
            </div>
        </div>
        <delete-dialog @deleteItem="deleteGroup" :maxWidth="325" ref="deleteDialogComponent">
            <span slot="title">{{ $t("_GROUP.CONFIRM_DELETE") }}?</span>
        </delete-dialog>
    </div>
</template>
<style lang="scss">
#d-group-profile {
    .theme--light.v-pagination .v-pagination__navigation {
        box-shadow: none !important;
    }

    .theme--light.v-pagination .v-pagination__item {
        box-shadow: none !important;
        font-size: 12px;
        margin: 0 !important;
    }

    .theme--light.v-pagination .v-pagination__item--active {
        color: #003e94 !important;
        background-color: transparent !important;
    }

    .v-pagination {
        justify-content: end !important;
    }
}
</style>

<script>
import { service } from "@/_services/Group/group.service.js";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import {
    _alert
} from "@/_helpers/function.js";
export default {
    components: {
        "delete-dialog": DeleteDialog,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t("STT"),
                    align: 'start',
                    sortable: false,
                    value: 'stt',
                },
                { text: this.$t("_BOOKING_GROUP.GROUP_PROFILE_CODE"), value: 'groupProfileCode' },
                { text: this.$t("_BOOKING_GROUP.GROUP_PROFILE_NAME"), value: 'nameVi' },

                { text: this.$t("BOOKINGS_GROUP"), value: 'totalBookingGroup', align: 'end', },
                { text: this.$t("_REGISTER.EMAIL"), value: 'contactEmail' },
                { text: this.$t("ADDRESS"), value: 'contactAddress' },
                { text: this.$t("ACTION"), value: 'status', sortable: false, },
            ],
            dataTable: [],
            search: null,
            page: 1,
            pageCount: 0,
            isLoading: true
        }
    },
    created() {
        this.getAll()
    },
    methods: {
        getAll() {
            this.isLoading = true;
            service
                .searchGroupProfile()
                .then(res => {
                    if (res.responseCode === 0) {
                        this.dataTable = res.data;
                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        deleteGroup(item) {
            service.deleteGroupProfile(item.id).then((res) => {
                _alert(res, this.$t(res.data), false);
                this.getAll();
            });
        },
        editItem(item) {
            this.$router.push({
                name: "detailProfilesGroup",
                params: { code: item.id }
            });
        },
        addNew() {
            this.$router.push({
                name: "detailProfilesGroup",
                params: { code: 0 }
            });
        },
    },
}
</script>